import { useOrderDraftStore } from '@/stores/OrderDraft';

export function OrderDraft() {
    const orderDraftStore = useOrderDraftStore();
    if (localStorage.getItem("cdlOrderKitBcK")) {
        orderDraftStore.setItems(true);
        return;
    }
    orderDraftStore.setItems(false);
}